import React from 'react';
import { translate } from 'react-i18next';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export class OtherRenewableEnergyDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getRenewableEnergyData() {
    return this.formRef.getFormData();
  }

  render() {
    const {
      name,
      energy,
      description,
      image,
    } = this.props.renewableEnergy;

    const { disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => this.formRef = ref}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="other-renewable-energy-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('other renewable energy name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="other-renewable-energy-energy"
          field="energy"
          type="number"
          label={<span>{t('energy')} ({t('kWh/Year')})</span>}
          placeholder="5.3"
          value={energy}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'energy')}
          {...customAttr}
        />
        <FieldGroup
          id="other-renewable-energy-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

OtherRenewableEnergyDetail.defaultProps = {
  renewableEnergy: {},
};

export default translate('translations', { withRef: true })(OtherRenewableEnergyDetail);



// WEBPACK FOOTER //
// ./src/components/renewable_energy/OtherRenewableEnergyDetail.js